import SpecialBuyModule from './SpecialBuyModule.component';

export default SpecialBuyModule;
